(ns api.products.helpers
  (:require
   [util.string :as str]))

(defn page-url [pagename]
  (->
    pagename
    (str/trim)
    (str/lower)
    (str/replace #"\s" "-")
    (str/replace #"[&]" "and")
    (str/replace #"[^a-zA-Z0-9-]*" "")
    (str ".htm")))

(defn query-url [pagename]
  (->
    pagename
    (str/replace #"\s" "-")
    (str/replace #"[&]" "and")
    (str/replace #"[/,'()\"]" "")))